import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const keys = () =>
    createEnv({
        server: {
            TRIGGER_API_ID: z.string().min(1),
            TRIGGER_SECRET_KEY: z.string().min(1),
            TRIGGER_API_URL: z.string().optional(),
            AWS_REGION: z.string().min(1),
            AWS_ACCESS_KEY_ID: z.string().min(1),
            AWS_SECRET_ACCESS_KEY: z.string().min(1),
            AWS_S3_BUCKET: z.string().min(1),
        },
        runtimeEnv: {
            TRIGGER_API_ID: process.env.TRIGGER_API_ID,
            TRIGGER_SECRET_KEY: process.env.TRIGGER_SECRET_KEY,
            TRIGGER_API_URL: process.env.TRIGGER_API_URL,
            AWS_REGION: process.env.AWS_REGION,
            AWS_ACCESS_KEY_ID: process.env.AWS_ACCESS_KEY_ID,
            AWS_SECRET_ACCESS_KEY: process.env.AWS_SECRET_ACCESS_KEY,
            AWS_S3_BUCKET: process.env.AWS_S3_BUCKET,
        }
    }); 